import {Directive, ElementRef, HostListener, inject} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[numbersOnly]',
})
export class NumbersOnlyDirective {
    private readonly control: NgControl = inject(NgControl);
    private readonly el: ElementRef = inject(ElementRef);

    private readonly regex: RegExp = new RegExp(/^\d+$/);
    private readonly specialKeys: Array<string> = [
        'Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Delete'
    ];

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (this.specialKeys.indexOf(event.key) !== -1 || event.ctrlKey || event.metaKey) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        const next: string = current.concat(event.key);

        if (next && !this.regex.exec(String(next))) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        const clipboardData = event.clipboardData || window['clipboardData'];
        this.control.control?.setValue(clipboardData.getData('text').replaceAll(/\D/g, ''));
        event.preventDefault();
    }
}
